import { render } from "./SeparatePage.vue?vue&type=template&id=1d4559c4&scoped=true"
import script from "./SeparatePage.vue?vue&type=script&lang=js"
export * from "./SeparatePage.vue?vue&type=script&lang=js"

import "./SeparatePage.vue?vue&type=style&index=0&id=1d4559c4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d4559c4"]])

export default __exports__